import { useEffect } from 'react';
import { CheckOutlined, LoadingOutlined } from '@ant-design/icons';
import { Col, Form, Row } from 'antd';
import { keys, startCase } from 'lodash';

import { Container, FieldByType } from 'components';

import { usePutRequest } from 'hooks';

import { TFieldProps } from 'types';

const { useForm } = Form;

export const DynamicForm = ({ data }: { data?: Record<string, string> }) => {
  const [form] = useForm();

  const [handlePatchField, { loading }] = usePutRequest({ url: '/configuration' });

  useEffect(() => {
    form.resetFields();
  }, [data]);

  const fields: TFieldProps[] = keys(data).filter((key) => key !== 'matching.percentageOfSnapsUsingAIMatching').map((key) => ({
    type: TFieldProps.type.Number,
    name: key,
    label: startCase(key.split('.').at(-1)),
    addonAfter: (
      loading
        ? <LoadingOutlined />
        : (
          <CheckOutlined
            className='cursor-pointer text-[green]'
            onClick={() => handlePatchField({
              callbackQueryParams: {
                key,
                value: form.getFieldValue(key),
              },
            })}
          />
        )
    ),
  }));

  return (
    <Container className='flex-none mb-4'>
      <h2 className='mb-10'>Fraud Dynamic Properties</h2>
      <Row>
        <Col xs={18}>
          <Form
            labelWrap
            form={form}
            initialValues={data}
            name='dynamic'
            colon={false}
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 6 }}
          >
            {fields.map((field) => (
              <FieldByType
                key={field.name.toString()}
                field={field}
              />
            ))}
          </Form>
        </Col>
      </Row>

    </Container>
  );
};
